<template>
    <Dialog
        :header-text="$t('Replace topic')"
        :value="true"
        @close_modal="$emit('close')"
    >
        <v-row no-gutters>
            <v-col cols="12">
                <div class="body-2 mb-4">
                    {{ $t("All tasks and plans with current topic will be replaced with the new selected topic.") }}
                </div>
                <dropdown
                    :items="replaceableTopics"
                    :selected="replaceableTopics.filter(x => x.id === selectedTopicId)"
                    name-key="name"
                    value-key="id"
                    show-selected-first
                    :label="$t('Topic')"
                    @input="selectedTopicId = $event.id"
                />
            </v-col>
        </v-row>
        <template slot="footer">
            <v-spacer />
            <secondary-button @click="$emit('close')">
                {{ $t("Cancel") }}
            </secondary-button>
            <primary-button
                :disabled="!selectedTopicId"
                @click="onReplaceClick"
            >
                {{ $t("Replace") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import {computed, ref} from "@vue/composition-api";
import { $t } from "@/i18n";
import Dialog from "@/components/Dialog";
import DialogModule from "@/store/modules/dialog";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiTopic from "@/api/topic/topic";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";

export default {
    name: "EditTopicReplaceDialog",
    components: {
        Dialog
    },
    props: {
        topics: {
            type: Array,
            required: true
        },
        currentTopicId: {
            type: Number,
            required: true
        },
        companyId: {
            type: Number,
            required: true
        }
    },
    setup(props, ctx) {
        const { openConfirmDialog, setConfirmOptions } = DialogModule();
        const { showFeedbackNotification } = FeedbackNotificationModule();
        const selectedTopicId = ref(null);

        const onReplaceConfirm = async () => {
            try {
                await ApiTopic.replaceTopics(props.currentTopicId, selectedTopicId.value, props.companyId)
                showFeedbackNotification($t("Topics replaced"))

                ctx.emit('close')
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const onReplaceClick = () => {
            const currentTopicName = props.topics.find(x => x.id === props.currentTopicId).name
            const selectedTopicName = props.topics.find(x => x.id === selectedTopicId.value).name

            setConfirmOptions({
                title: $t("Notice!"),
                text: $t("All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?").format(currentTopicName, selectedTopicName),
                confirm_text: $t("Confirm"),
                cancel_text: $t("Cancel"),
                action: onReplaceConfirm
            });
            openConfirmDialog();
        }

        const replaceableTopics = computed(() => {
            return props.topics.filter(x => x.id !== props.currentTopicId)
        })

        return {
            selectedTopicId,
            onReplaceClick,
            replaceableTopics
        };
    }
};
</script>
